module.exports = __webpack_public_path__ + "static/media/powerby.72007459.png";